// File: src/pages/registration/StepIcons.js

import React from 'react';

import {
  LuCircleUser,
  LuMailSearch,
  LuEllipsis,
  LuPhone,
  LuMessageSquareText,
  LuCalendar1,
  LuCamera,
  LuCirclePlus,
  LuFileText,
} from 'react-icons/lu';

// Return the correct icon based on step

export function getStepIcon(step) {
  switch (step) {
    case 2:
      return <LuCircleUser style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 3:
      return <LuMailSearch style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 4:
      return <LuEllipsis style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 5:
      return <LuPhone style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 6:
      return <LuMessageSquareText style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 7:
      return <LuCalendar1 style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 8:
      return <LuCamera style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 9:
      return <LuCirclePlus style={{ fontSize: '1.5rem', color: '#000' }} />;

    case 10:
      return <LuFileText style={{ fontSize: '1.5rem', color: '#000' }} />;

    default:
      return <LuFileText style={{ fontSize: '1.5rem', color: '#000' }} />;
  }
}
